import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';

import { CommunityProgramsService } from '../+products/community/community-programs.service';
import { ProductOrchestratorService } from '../+products/product-orchestrator.service';
import { AppInsightsService } from '../app-insights/appinsights.service';
import { InterviewProductDataProviderService } from './abstract-interview-product-data-provider.service';


@Injectable()
export class InterviewCommunityDataProviderService extends InterviewProductDataProviderService {

    constructor(store: Store,
        communityProgramsService: CommunityProgramsService,
        productOrchestratorService: ProductOrchestratorService,
        appInsightsService: AppInsightsService
    ) {
        super(store, communityProgramsService, productOrchestratorService, appInsightsService);
    }
}
